import React from 'react';
import { SequentialFamilyImport } from '@/components/admin/import/SequentialFamilyImport';

export default function TestSequentialImport() {
  return (
    <div className="container mx-auto py-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Test: Sequential Family Import</h1>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
          <p className="text-yellow-800">
            ⚠️ This is a test feature. The existing import tool is still available and unchanged.
          </p>
        </div>
        <SequentialFamilyImport />
      </div>
    </div>
  );
}